import { render } from "./MailIcon.vue?vue&type=template&id=43b2ebde"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MailIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43b2ebde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43b2ebde', __exports__)) {
    api.reload('43b2ebde', __exports__)
  }
  
  module.hot.accept("./MailIcon.vue?vue&type=template&id=43b2ebde", () => {
    api.rerender('43b2ebde', render)
  })

}


export default __exports__